import MontuToastProvider from "@repo/components/src/globalProviders/toast";
import { Toast, ToastDescription } from "@repo/components/src/ui/toast";
import { router, useLocalSearchParams } from "expo-router";
import { useEffect, useRef } from "react";

const SUCCESS_STATUSES = new Set(["approved"]);
const PENDING_STATUSES = new Set([
  "pending",
  "in_process",
  "in_mediation",
  "authorized",
]);

const showToast = (
  action: "success" | "info" | "error",
  description: string,
) => {
  MontuToastProvider.show({
    placement: "bottom",
    duration: 4000,
    render: ({ id }) => (
      <Toast nativeID={`toast-${id}`} action={action} variant="solid">
        <ToastDescription size="sm">{description}</ToastDescription>
      </Toast>
    ),
  });
};

/**
 * Shows a toast when the brand lands back on this page after being redirected
 * to an external Rebill/MercadoPago checkout, then strips the payment query
 * params so a refresh doesn't re-fire it.
 */
export const usePaymentStatusToast = () => {
  const { payment_status: paymentStatus } = useLocalSearchParams<{
    payment_status?: string;
    payment_provider?: string;
  }>();
  const hasHandled = useRef(false);

  useEffect(() => {
    if (!paymentStatus || hasHandled.current) return;
    hasHandled.current = true;

    if (SUCCESS_STATUSES.has(paymentStatus)) {
      showToast("success", "Pago confirmado.");
    } else if (PENDING_STATUSES.has(paymentStatus)) {
      showToast("info", "Tu pago está siendo procesado.");
    } else {
      showToast("error", "No pudimos procesar tu pago.");
    }

    router.setParams({ payment_status: undefined });
  }, [paymentStatus]);
};

export default usePaymentStatusToast;
